import {
  useCurrentLocale,
  useCurrentLocaleDirection,
  useHaveTranslationsCompleted,
  useTranslations,
} from '@ms/yammer-i18n-react';
import { TranslationsContextProvider } from '@ms/yammer-web-support/dist/translations';
import type { FC, PropsWithChildren } from 'react';
import React from 'react';

const translationsContextProviderValue = {
  useLoader: useTranslations,
  useHaveTranslationsCompleted,
  useCurrentLocale,
  useCurrentLocaleDirection,
};

const ReduxTranslationsContextProvider: FC<PropsWithChildren> = ({ children }) => (
  <TranslationsContextProvider value={translationsContextProviderValue}>{children}</TranslationsContextProvider>
);

export default ReduxTranslationsContextProvider;
